import React from 'react';
import { FormFieldWrapper } from '@plone/volto/components';
import VoltoDateViewWidget from '@plone/volto/components/theme/Widgets/DateWidget';

const DateViewWidget = (props) => {
  return (
    <FormFieldWrapper {...props}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          color: '##7c7c7c',
          fontWeight: 'bold',
        }}
      >
        <VoltoDateViewWidget {...props} />
        {!props.value && <span>-</span>}
      </div>
    </FormFieldWrapper>
  );
};

export default DateViewWidget;
